import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Swiper blog posts categories slider
const blogPostsCategoriesSlider = document.querySelectorAll(
    '.blog-posts-categories-slider'
);

if (blogPostsCategoriesSlider) {
    blogPostsCategoriesSlider.forEach((slider) => {
        const sliderId = slider.dataset.sliderId;
        const swiper = new Swiper(slider, {
            modules: [Navigation],
            loop: false,
            speed: 300,
            height: 'auto',
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            spaceBetween: 30,
            navigation: {
                nextEl: `.swiper-custom-next-${sliderId}`,
                prevEl: `.swiper-custom-prev-${sliderId}`,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
            },
        });
    });
}

// End Swiper blog posts categories slider
